jQuery(document).ready(function ($) {
    /*Move jo footer*/
    $('.footer__content-top .footer-block.grid__item .footer-block__details-content > li').on('click', function() {
        $(this).find('.item-icon').toggleClass('active');
    });

    /*Search header*/

    $('.search-modal__form form').on('click',' .clear-text', function(e) {
        e.preventDefault();
        $(this).prev('input').val('');
        $(this).prev('input').removeClass('valid-text');
        return false;
    });

    $('.search-modal__form form').on('focus blur keyup','.search__input', function(e) {
        e.preventDefault();
        if($(this).val().length) {
            $(this).addClass('valid-text');
        } else {
            $(this).removeClass('valid-text');
        }
    });



    /* MINICART FUNCTIONS */
    //reinit minicart
    function refreshMiniCart(lineitem, quantity) {
        $.ajax({
            method: "GET",
            url: "/cart",
            data: {"view": "ajax"},
            xhrFields: {
                withCredentials: true
            },
            dataType: 'html',
            success: function(response) {

                var CartCount = $(response).find('.cartCount').html();
                // console.log(CartCount);
                var contentCartHtml = $(response).find('.mini-cart-wrapper').first().html();
                //console.log(contentCartHtml);
                if(CartCount == undefined){
                    CartCount = 0;
                    $('.cart-count-bubble').addClass('hidden');
                } else {
                    $('.cart-count-bubble').removeClass('hidden');
                }

                $('.cartCount').text(CartCount);

                if (contentCartHtml) {
                    $('.mini-cart-wrapper').html(contentCartHtml);
                }
            }
        });
    }

    // Toggle mini-cart
    $('.header__icon.header__icon--cart').on('click', function(e) {
        if($(this).next('.mini-cart-wrapper').hasClass('show')){
            $('body').removeClass('open-minicart');
            $(this).next('.mini-cart-wrapper').removeClass('show');
        }else{
            $('body').addClass('open-minicart');
            $(this).next('.mini-cart-wrapper').toggleClass('show');
        }
    });

    // Clse minicart
    $(document).on('click', '.close-minicart', function(e) {
        $('.mini-cart-wrapper').removeClass('show');
        $('body').removeClass('open-minicart');
    });

    // Click outside clode minicart
    $(document).on( "click", '.bg-minicart-close', function(e) {
        $('.mini-cart-wrapper').removeClass('show');
        $('body').removeClass('open-minicart');
    });

    // Remove minicart
    $(document).on('click', '.cart-details .remove-item .delete', function() {
        var id = $(this).data('cart-item');
        var key = $(this).data('cart-key');
        var labelTitle = $(this).data('label');
        if (labelTitle == 'Gift-wrapping'){
            // console.log('active');
        }
        if (key) {
            $('.mini-cart-content #mincart-loading').show();
            $.ajax({
                method: "POST",
                url: "/cart/update.js",
                data: "updates["+ key +"]=0",
                dataType: "json",
                success: function(response) {
                    refreshMiniCart();
                },
                error: function(XMLHttpRequest, textStatus) {
                    $('.mini-cart-content #mincart-loading').hide();
                    handleError(XMLHttpRequest);
                }
            });
        }
    });

    // Update Minicart
    function updateMinicart(product_id, product_quantity) {
        var id = product_id;
        var qty = product_quantity;
        $.ajax({
            method: "POST",
            url: "/cart/update.js",
            data: "updates["+ id +"]=" + qty,
            dataType: "json",
            success: function(response) {
                $('.mini-cart-content #mincart-loading').show();
                refreshMiniCart();
            },
            error: function(XMLHttpRequest, textStatus) {
                $('.mini-cart-content #mincart-loading').hide();
                handleError(XMLHttpRequest);
            }
        });
    }

    // Handle quantity on minicart
    $(document).on('click', '.mini-cart-wrapper .product-form-item .product-plus', function() {
        var $inputQty = $(this).closest('.product-form-item').find('.product-form__input--quantity').first();
        var qty = parseInt($inputQty.val());

        $(this).prop('disabled', true);
        $(this).addClass('disabled');

        $inputQty.val(qty).trigger('change');
    });

    $(document).on('click', '.mini-cart-wrapper .product-form-item .product-minus', function() {
        var $inputQty = $(this).closest('.product-form-item').find('.product-form__input--quantity').first();
        var qty = parseInt($inputQty.val());

        $(this).prop('disabled', true);
        $(this).addClass('disabled');

        $inputQty.val(qty).trigger('change');
    });

    $(document).on('change', '.product-form__input.product-form__input--quantity', function() {
        let that = $(this);
        let item_id = $(this).closest('.product-form-item').data('id');
        let qty = parseInt(that.val());
        if(qty < 0) {
            qty = 1;
            updateMinicart(item_id, qty);
        } else {
            updateMinicart(item_id, qty);
        }
    });

    $(document).on('click', '.header__icon--cart', function() {
        $('.mini-cart-content #mincart-loading').show();
        $.ajax({
            method: "GET",
            url: "/cart",
            data: {"view": "ajax"},
            success: function(response) {
                $('.mini-cart-content #mincart-loading').show();
                refreshMiniCart();
            },
            error: function(XMLHttpRequest, textStatus) {
                $('.mini-cart-content #mincart-loading').hide();
                handleError(XMLHttpRequest);
            }
        });
    });

    $(window).on('load resize', function () {
        var vh = window.innerHeight * 0.01;
        var vw = window.innerWidth * 0.01;
        document.documentElement.style.setProperty('--vwbrower', `${vw}px`);
        document.documentElement.style.setProperty('--vhbrower', `${vh}px`);
    });
});

